import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ConversationAgentEntity } from './conversation-agent.entity';

@Entity('_conversation_agent_monthly_usage')
@Index(['conversationAgentId', 'year', 'month'], { unique: true })
@Index(['conversationAgentId'])
@Index(['year', 'month'])
export class ConversationAgentMonthlyUsageEntity extends BaseEntity {
	// Foreign Key to Agent
	@Column({
		name: '_fk__conversation_agent__id',
		type: 'int',
		unsigned: true,
	})
	public conversationAgentId!: number;

	@ManyToOne(() => ConversationAgentEntity)
	@JoinColumn({ name: '_fk__conversation_agent__id' })
	public conversationAgent?: ConversationAgentEntity;

	// Time Period
	@Column({ type: 'int', unsigned: true })
	public year!: number;

	@Column({ type: 'int', unsigned: true })
	public month!: number; // 1-12

	// Usage (in SECONDS and TOKENS) - NO ROLLOVER
	@Column({
		type: 'int',
		unsigned: true,
		default: 0,
		comment: 'Voice call duration for this agent',
	})
	public voiceSeconds!: number;

	@Column({
		type: 'int',
		unsigned: true,
		default: 0,
		comment: 'LLM tokens used by this agent',
	})
	public llmTokens!: number;

	// Business Days Tracking (for forecasting)
	@Column({
		type: 'int',
		unsigned: true,
		default: 0,
		comment: 'Voice seconds on Mon-Fri',
	})
	public weekdaySeconds!: number;

	@Column({
		type: 'int',
		unsigned: true,
		default: 0,
		comment: 'Voice seconds on Saturday',
	})
	public saturdaySeconds!: number;

	@Column({
		type: 'int',
		unsigned: true,
		default: 0,
		comment: 'Voice seconds on Sunday',
	})
	public sundaySeconds!: number;

	@Column({
		type: 'int',
		unsigned: true,
		default: 0,
		comment: 'LLM tokens on Mon-Fri',
	})
	public weekdayTokens!: number;

	@Column({
		type: 'int',
		unsigned: true,
		default: 0,
		comment: 'LLM tokens on Saturday',
	})
	public saturdayTokens!: number;

	@Column({
		type: 'int',
		unsigned: true,
		default: 0,
		comment: 'LLM tokens on Sunday',
	})
	public sundayTokens!: number;

	// Activity Stats
	@Column({ type: 'int', unsigned: true, default: 0 })
	public totalVoice!: number;

	@Column({ type: 'int', unsigned: true, default: 0 })
	public totalChats!: number;

	// Warning System
	@Column({
		type: 'timestamp',
		nullable: true,
		comment: 'Last time warning email was sent (used to enforce 24h limit)',
	})
	public lastWarningEmailSent?: Date;
}
